function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

function debounce(func) {
      var timer;
      return function(event) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(func, 100, event);
      };
  }

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

// ===== hoverIntent.js =====
  function hoverIntent(el, options) {
  const settings = Object.assign({
    sensitivity: 7,     
    interval: 100,     
    timeout: 200,      
    over: () => {},    
    out: () => {}     
  }, options);

  let x, y, pX, pY;
  let h = null, state = 0, timeoutId = null;

  function track(e) {
    x = e.clientX;
    y = e.clientY;
  }

  function compare(e) {
    if (timeoutId) clearTimeout(timeoutId);
    if ((Math.abs(pX - x) + Math.abs(pY - y)) < settings.sensitivity) {
      el.removeEventListener("mousemove", track);
      state = 1;
      settings.over.call(el, e);
    } else {
      pX = x; pY = y;
      h = setTimeout(() => compare(e), settings.interval);
    }
  }

  function dispatchOver(e) {
    if (h) clearTimeout(h);
    el.addEventListener("mousemove", track);
    pX = e.clientX; pY = e.clientY;
    h = setTimeout(() => compare(e), settings.interval);
  }

  function dispatchOut(e) {
    if (h) clearTimeout(h);
    el.removeEventListener("mousemove", track);
    if (state === 1) {
      timeoutId = setTimeout(() => {
        settings.out.call(el, e);
        state = 0;
      }, settings.timeout);
    }
  }

  el.addEventListener("mouseenter", dispatchOver);
  el.addEventListener("mouseleave", dispatchOut);
}